import React, { Component } from 'react'
import { Wrapper, StyledModal } from './ModalWrapper.styles'

class Modal extends Component {
  render() {
    const { children, fullScreen, ...rest } = this.props

    return (
      <Wrapper fullScreen={fullScreen}>
        <StyledModal {...rest}>{children}</StyledModal>
      </Wrapper>
    )
  }
}

export default Modal
